import type { OfferId } from '../core/types';

export interface OfferMeta {
  name: string;
  desc: string;
  kind: 'weapon' | 'passive';
}

/** 三选一条目文案（卡片展示用；数值以 balance 为准）。 */
export const OFFER_META: Record<OfferId, OfferMeta> = {
  boomerang: { name: '回旋镖', desc: '绕身旋转，近身即伤', kind: 'weapon' },
  staff: { name: '法杖', desc: '自动索敌弹，轻微追踪', kind: 'weapon' },
  whip: { name: '鞭', desc: '自动锁定最近敌人，扇形横扫', kind: 'weapon' },
  arrow: { name: '哨箭', desc: '自动锁定最近敌人，射出穿透箭', kind: 'weapon' },
  attack_speed: { name: '攻速', desc: '武器冷却 -10% / 级', kind: 'passive' },
  area: { name: '范围', desc: '攻击范围 +10% / 级', kind: 'passive' },
  projectile_speed: { name: '弹速', desc: '弹道速度 +12% / 级', kind: 'passive' },
  magnet: { name: '磁铁', desc: '拾取半径 +30% / 级', kind: 'passive' },
  crit: { name: '暴击', desc: '暴击率 +8% / 级，暴击 ×2', kind: 'passive' },
  shield: { name: '护盾', desc: '格挡一次伤害', kind: 'passive' },
  calm: { name: '冷静', desc: '血越少攻击越高', kind: 'passive' },
  greed: { name: '贪婪', desc: '金币 +25% / 级', kind: 'passive' },
};

export const EVOLUTION_NAME: Record<string, string> = {
  multi_boomerang: '多重回旋',
  executioner: '处刑者',
  arcane_storm: '奥术风暴',
  sun_piercer: '贯日',
};
